// extracted by mini-css-extract-plugin
module.exports = {"icon":"IconTextLarge_icon__3olP0","message":"IconTextLarge_message__1bhJf","header":"IconTextLarge_header__HsimX"};